/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export { DEFAULT_URL_MATCHER } from './default-url-matcher';
export * from './url-matcher-factory';
